/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Run_Status_DoneInputs */

const vi_irrigation_run_status_done = /** @type {(inputs: Irrigation_Run_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xong`)
};

/**

* @param {Irrigation_Run_Status_DoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_status_done = /** @type {((inputs?: Irrigation_Run_Status_DoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_Status_DoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_status_done(inputs)
});